export const UPDATE_BOOKING_MESSAGES = {
  INVALID_BOOKING_LINK:
    "Invalid booking link or encryption key mismatch.",

  FETCH_REQUEST_DATA_FAILED:
    "Failed to fetch request data",

  LOAD_BOOKING_DETAILS_FAILED:
    "Failed to load booking details.",

  MANAGER_APPROVAL_LOCKED:
    "Booking details will be enabled after any assigned manager approves the request.",

  BOOKING_EDIT_NOT_ALLOWED:
    "Booking details can no longer be edited after approval.",

  DELETE_FILE_FAILED:
    "Failed to delete file",

  SEND_BOOKING_EMAIL_FAILED:
    "Failed to send booking email",

  UPDATE_BOOKING_DETAILS_FAILED:
    "Failed to update booking details.",
};